(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["martha-quantity-breaks"] && !Shopify.designMode) return;
  try {
    const updateMarthaSingleVariant = (select) => {
    const selectors = select.closest('[data-martha-variant-selectors]');
    if (Number(selectors?.dataset.bundleQuantity) !== 1) return;

    const form = select.closest('form');
    const variantIdInput = form?.querySelector('input[name="id"]');
    if (!variantIdInput || !select.value) return;

    variantIdInput.value = select.value;
    variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const updateMarthaBundleState = (option) => {
    const root = option.closest('[data-martha-quantity-breaks]');
    const form = root?.closest('form');
    const quantityInput = form?.querySelector('input[name="quantity"]');
    const quantity = Number(option.value);

    root?.querySelectorAll('[data-martha-variant-selectors]').forEach((selectors) => {
      const isActive = Number(selectors.dataset.bundleQuantity) === quantity;
      selectors.hidden = !isActive;
      selectors.querySelectorAll('[data-martha-variant-select]').forEach((select) => {
        select.disabled = !isActive;
      });
    });

    const singleVariantSelect = root?.querySelector(
      '[data-martha-variant-selectors][data-bundle-quantity="1"] [data-martha-variant-select]'
    );
    if (quantity === 1 && singleVariantSelect) updateMarthaSingleVariant(singleVariantSelect);

    if (quantityInput) {
      quantityInput.value = option.value;
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  document.addEventListener('change', (event) => {
    const option = event.target.closest?.('.martha-quantity-breaks [data-martha-quantity-option]');
    if (option) updateMarthaBundleState(option);

    const variantSelect = event.target.closest?.('.martha-quantity-breaks [data-martha-variant-select]');
    if (variantSelect) updateMarthaSingleVariant(variantSelect);
  });

  document.addEventListener('variant:update', (event) => {
    const variantId = String(event.detail?.resource?.id || '');
    const productId = String(event.detail?.data?.productId || '');
    if (!variantId) return;

    document.querySelectorAll('.martha-quantity-breaks').forEach((root) => {
      const productForm = root.closest('product-form-component');
      if (productId && productForm?.dataset.productId !== productId) return;

      root.querySelectorAll('[data-martha-variant-select]').forEach((select) => {
        const hasVariant = Array.from(select.options).some((option) => option.value === variantId);
        if (hasVariant) select.value = variantId;
      });
    });
  });

  const initializeMarthaQuantityBreaks = () => {
    document.querySelectorAll('.martha-quantity-breaks').forEach((root) => {
      const checkedOption = root.querySelector('[data-martha-quantity-option]:checked');
      if (checkedOption) updateMarthaBundleState(checkedOption);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMarthaQuantityBreaks, { once: true });
  } else {
    initializeMarthaQuantityBreaks();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["track-set-quantity-breaks"] && !Shopify.designMode) return;
  try {
    const updateTrackSetSingleVariant = (select) => {
    const selectors = select.closest('[data-martha-variant-selectors]');
    if (Number(selectors?.dataset.bundleQuantity) !== 1) return;

    const form = select.closest('form');
    const variantIdInput = form?.querySelector('input[name="id"]');
    if (!variantIdInput || !select.value) return;

    variantIdInput.value = select.value;
    variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const updateTrackSetBundleState = (option) => {
    const root = option.closest('[data-martha-quantity-breaks]');
    const form = root?.closest('form');
    const quantityInput = form?.querySelector('input[name="quantity"]');
    const quantity = Number(option.value);

    root?.querySelectorAll('[data-martha-variant-selectors]').forEach((selectors) => {
      const isActive = Number(selectors.dataset.bundleQuantity) === quantity;
      selectors.hidden = !isActive;
      selectors.querySelectorAll('[data-martha-variant-select]').forEach((select) => {
        select.disabled = !isActive;
      });
    });

    const singleVariantSelect = root?.querySelector(
      '[data-martha-variant-selectors][data-bundle-quantity="1"] [data-martha-variant-select]'
    );
    if (quantity === 1 && singleVariantSelect) updateTrackSetSingleVariant(singleVariantSelect);

    if (quantityInput) {
      quantityInput.value = '1';
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  document.addEventListener('change', (event) => {
    const option = event.target.closest?.('.track-set-quantity-breaks [data-martha-quantity-option]');
    if (option) updateTrackSetBundleState(option);

    const variantSelect = event.target.closest?.('.track-set-quantity-breaks [data-martha-variant-select]');
    if (variantSelect) updateTrackSetSingleVariant(variantSelect);
  });

  document.addEventListener('variant:update', (event) => {
    const variantId = String(event.detail?.resource?.id || '');
    const productId = String(event.detail?.data?.productId || '');
    if (!variantId) return;

    document.querySelectorAll('.track-set-quantity-breaks').forEach((root) => {
      const productForm = root.closest('product-form-component');
      if (productId && productForm?.dataset.productId !== productId) return;

      root.querySelectorAll('[data-martha-variant-select]').forEach((select) => {
        const hasVariant = Array.from(select.options).some((option) => option.value === variantId);
        if (hasVariant) select.value = variantId;
      });
    });
  });

  const initializeTrackSetQuantityBreaks = () => {
    document.querySelectorAll('.track-set-quantity-breaks').forEach((root) => {
      const checkedOption = root.querySelector('[data-martha-quantity-option]:checked');
      if (checkedOption) updateTrackSetBundleState(checkedOption);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTrackSetQuantityBreaks, { once: true });
  } else {
    initializeTrackSetQuantityBreaks();
  }
  } catch(e) { console.error(e); }
})();

})();
